export const GET_RUMAHTAHFIDZ_REQUEST = "rumahtahfidz/get/request";
export const GET_RUMAHTAHFIDZ_SUCCEED = "rumahtahfidz/get/succeed";
export const GET_RUMAHTAHFIDZ_FAILED = "rumahtahfidz/get/failed";

export const GET_BY_ID_RUMAHTAHFIDZ_REQUEST = "rumahtahfidz/getid/request";
export const GET_BY_ID_RUMAHTAHFIDZ_SUCCEED = "rumahtahfidz/getid/succeed";
export const GET_BY_ID_RUMAHTAHFIDZ_FAILED = "rumahtahfidz/getid/failed";

export const GET_BY_RUMAHTAHFIDZ_REQUEST =
  "rumahtahfidz/getrumahtahfidz/request";
export const GET_BY_RUMAHTAHFIDZ_SUCCEED =
  "rumahtahfidz/getrumahtahfidz/succeed";
export const GET_BY_RUMAHTAHFIDZ_FAILED = "rumahtahfidz/getrumahtahfidz/failed";

export const GET_BY_PONDOKID_RUMAHTAHFIDZ_REQUEST =
  "rumahtahfidz/getbypondokidrumahtahfidz/request";
export const GET_BY_PONDOKID_RUMAHTAHFIDZ_SUCCEED =
  "rumahtahfidz/getbypondokidrumahtahfidz/succeed";
export const GET_BY_PONDOKID_RUMAHTAHFIDZ_FAILED =
  "rumahtahfidz/getbypondokidrumahtahfidz/failed";

export const CREATE_RUMAHTAHFIDZ_REQUEST = "rumahtahfidz/create/request";
export const CREATE_RUMAHTAHFIDZ_SUCCEED = "rumahtahfidz/create/succeed";
export const CREATE_RUMAHTAHFIDZ_FAILED = "rumahtahfidz/create/failed";

export const DELETE_RUMAHTAHFIDZ_REQUEST = "rumahtahfidz/delete/request";
export const DELETE_RUMAHTAHFIDZ_SUCCEED = "rumahtahfidz/delete/succeed";
export const DELETE_RUMAHTAHFIDZ_FAILED = "rumahtahfidz/delete/failed";

export const UPDATE_RUMAHTAHFIDZ_REQUEST = "rumahtahfidz/update/request";
export const UPDATE_RUMAHTAHFIDZ_SUCCEED = "rumahtahfidz/update/succeed";
export const UPDATE_RUMAHTAHFIDZ_FAILED = "rumahtahfidz/update/failed";

export const UPDATE_RUMAHTAHFIDZ_NOFILE_REQUEST =
  "rumahtahfidz/updatenofile/request";
export const UPDATE_RUMAHTAHFIDZ_NOFILE_SUCCEED =
  "rumahtahfidz/updatenofile/succeed";
export const UPDATE_RUMAHTAHFIDZ_NOFILE_FAILED =
  "rumahtahfidz/updatenofile/failed";
